import React, { useEffect, useState, useContext } from "react";
import { redirect, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RetrieveSelectedFlight } from "../../Services/API";
import { RetrieveAgentDetails } from "../../Services/API";
import { AddPassengerDetails } from "../../Services/API";
import { CollectPayment } from "../../Services/API";
import { FlightBooking } from "../../Services/API";
import { SpecialService } from '../../Services/API';
import SeatAvailability from "../../Products/Flight/SeatAvailability";
import { AuthContext } from "../../Routes/AuthProvider"
import { GetSeatAvailability } from "../../Services/API";
import { ApprovalRequest } from "../../Services/ApprovalAPI";

const Booking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { name, userName } = useContext(AuthContext);
  const queryParams = new URLSearchParams(location.search);
  const [show, setShow] = useState(false);

  const showHide = () => {
    setShow(!show);
  };
  const [showMeal, setShowMeal] = useState(false);
  const [showSeat, setShowSeat] = useState(false);

  const [selectedFlight, setSelectedFlight] = useState(null);

  function getParamIgnoreCase(key) {
    for (const [k, v] of queryParams.entries()) {
      if (k.toLowerCase() === key.toLowerCase()) {
        return v;
      }
    }
    return null;
  }

  const referenceNo = getParamIgnoreCase("ReferenceNo");
  const clientCode = getParamIgnoreCase("ClientCode");
  const key = getParamIgnoreCase("Key");

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    confirmName: "",
    payment: "",
  });

  const [selectedFlightData, setSelectedFlightData] = useState(null); // Store API response here
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [totalBFare, setTotalBFare] = useState(0);
  const [totalFare, setTotalFare] = useState(0);
  const [adultTotalBaseFare, setAdultTotalBaseFare] = useState(0);
  const [childTotalBaseFare, setChildTotalBaseFare] = useState(0);
  const [infantTotalBaseFare, setInfantTotalBaseFare] = useState(0);
  const [flightAvailibilies, setFlightAvailibilies] = useState(null);
  const [agencyDetails, setAgencyDetails] = useState(null);
  const [paxCount, setPaxCount] = useState(null);
  const [oF, setOF] = useState(null);
  const [rF, setRF] = useState(null);
  const [travellers, setTravellers] = useState({ adults: [], children: [], infants: [] });
  const [contactDetails, setContactDetails] = useState({ emailId: "", countryCode: "", mobile: "", });
  const [ssrInfo, setSsrInfo] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [paymentError, setPaymentError] = useState("");
  const [termsError, setTermsError] = useState("");
  const [selectedSeats, setSelectedSeats] = useState([]);
  const ChangeContactDetails = (e) => {
    const { name, value } = e.target;
    setContactDetails((prev) => ({ ...prev, [name]: value }));
  };

  const [activeSegment, setActiveSegment] = useState(null);
  const [seatLayout, setSeatLayout] = useState(null);
  const [loadingSeats, setLoadingSeats] = useState(false);


  //Automatically call API when params are available
  useEffect(() => {
    if (referenceNo && clientCode && key) {
      fetchFlightData(referenceNo, clientCode, key);
    } else {
      console.warn("Missing query parameters");
    }
  }, [referenceNo, clientCode, key]);

  const fetchFlightData = async (referenceNo, clientCode, key) => {
    try {
      setLoading(true);
      setError("");

      const params = {
        ReferenceNo: referenceNo,
        ClientCode: clientCode,
        Key: key,
      };

      const response = await RetrieveSelectedFlight(params);
      const agentDetailsResponse = await RetrieveAgentDetails(userName);
      console.log("RetrieveSelectedFlight:", response.data);
      // debugger;
      // const OF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 1) || [];
      // const RF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 2) || [];

      const OF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 1) || [];
      const RF = response.data?.flightAvailibilies?.[1]?.segments?.filter(t => t.flightCount === 1) || [];
      setOF(OF);
      setRF(RF);

      console.log("OF:", OF);
      console.log("RF:", RF);

      let TotalBFare = 0;
      let TotalFare = 0;
      if (response.data && response.data.flightAvailibilies) {
        response.data.flightAvailibilies.forEach(item => {
          TotalBFare += parseFloat(item.fareDetails.totalBaseFare || 0);
          TotalFare += parseFloat(item.fareDetails.totalFare || 0);
        });
      }
      setTotalBFare(TotalBFare);
      setTotalFare(TotalFare);

      setFlightAvailibilies(response.data.flightAvailibilies);
      setAgencyDetails(agentDetailsResponse.data);

      setContactDetails({
        emailId: agentDetailsResponse.data.agencyDetails?.email || "",
        countryCode: agentDetailsResponse.data.agencyDetails?.countryCode || "91",
        mobile: agentDetailsResponse.data.agencyDetails?.phoneNumber || "",
      });

      const OB = [...response.data.flightAvailibilies];
      //console.log("OB:", OB[0].adult);
      setPaxCount(OB);

      let adultTotalBaseFare = 0;
      if (response.data.flightAvailibilies && response.data.flightAvailibilies.length > 0) {
        response.data.flightAvailibilies.forEach((flight) => {
          flight.fareDetails.paxFareDetails.forEach((pax) => {
            if (pax.paxType === "ADT") {
              adultTotalBaseFare += Number(pax.paxBaseFare);
            }
          });
        });
      }
      setAdultTotalBaseFare(adultTotalBaseFare)

      let childTotalBaseFare = 0;
      if (response.data.flightAvailibilies && response.data.flightAvailibilies.length > 0) {
        response.data.flightAvailibilies.forEach((flight) => {
          flight.fareDetails.paxFareDetails.forEach((pax) => {
            if (pax.paxType === "CHD") {
              childTotalBaseFare += Number(pax.paxBaseFare);
            }
          });
        });
      }
      setChildTotalBaseFare(childTotalBaseFare)

      let infantTotalBaseFare = 0;
      if (response.data.flightAvailibilies && response.data.flightAvailibilies.length > 0) {
        response.data.flightAvailibilies.forEach((flight) => {
          flight.fareDetails.paxFareDetails.forEach((pax) => {
            if (pax.paxType === "INFT") {
              infantTotalBaseFare += Number(pax.paxBaseFare);
            }
          });
        });
      }
      setInfantTotalBaseFare(infantTotalBaseFare)

    } catch (err) {
      //console.error(" Error fetching flight data:", err);
      setError("Failed to load flight details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const nextStep = () => {
    const { isValid, firstErrorField } = validateTravellers();

    if (!isValid && firstErrorField) {
      const { type, index, field } = firstErrorField;
      const inputName =
        type === "adult" || type === "child" || type === "infant"
          ? `${type === "adult" ? "adults" : type === "child" ? "children" : "infants"}[${index}].${field}`
          : null;

      if (inputName) {
        const fieldElement = document.querySelector(`[name="${inputName}"]`);
        if (fieldElement) {
          fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          fieldElement.focus();
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      return;
    }

    // Continue to next step
    setStep(step + 1);
  };


  const prevStep = () => setStep((prev) => prev - 1);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleTravellerChange = (type, index, field, value) => {
    setTravellers(prev => {
      const updatedType = [...prev[type]];
      updatedType[index] = { ...updatedType[index], [field]: value };
      return { ...prev, [type]: updatedType };
    });

    // remove error when typing
    setError(prev => ({
      ...prev,
      [`${type}_${index}_${field}`]: ""
    }));
  };

  // const validateTravellers = () => {
  //   let newErrors = {};
  //   const isEmpty = (value) => {
  //     if (value === null || value === undefined) return true;
  //     if (typeof value === "object") return true;
  //     if (value === 0) return false;
  //     if (value.toString().trim() === "") return true;
  //     if (value.toString().trim().toLowerCase() === "select") return true;
  //     return false;
  //   };

  //   const isValidName = (value) => {
  //     if (!value) return false;
  //     const name = value.trim();
  //     const regex = /^[A-Za-z ]{2,50}$/;
  //     return regex.test(name);
  //   };

  //   const check = (type, index, field, label, value, isNameField = false) => {
  //     if (isEmpty(value)) {
  //       newErrors[`${type}_${index}_${field}`] = `${label} is required`;
  //     }

  //     if (isNameField && !isValidName(value)) {
  //       newErrors[`${type}_${index}_${field}`] =
  //         `${label} must be A–Z only and 2–50 characters`;
  //     }
  //   };

  //   const validateType = (list, typeName) => {
  //     if (!Array.isArray(list)) list = [];

  //     if (list.length === 0) {
  //       newErrors[`${typeName}_empty`] = `${typeName.toUpperCase()} details are required`;
  //       return;
  //     }

  //     list.forEach((t, i) => {
  //       if (!t) t = {};

  //       check(typeName, i, "title", "Title", t.title);
  //       check(typeName, i, "firstName", "First Name", t.firstName, true);
  //       check(typeName, i, "lastName", "Last Name", t.lastName, true);
  //       check(typeName, i, "dob", "Date of Birth", t.dob);
  //       check(typeName, i, "airline", "Airline", t.airline);
  //       //check(typeName, i, "frequentFlyerNo", "frequent FlyerNo", t.frequentFlyerNo);

  //       // passport fields
  //       if ("passportNo" in t) {
  //         check(typeName, i, "passportNo", "Passport No", t.passportNo);
  //         check(typeName, i, "issuingCountry", "Issuing Country", t.issuingCountry);
  //         check(typeName, i, "nationality", "Nationality", t.nationality);
  //         check(typeName, i, "issueDate", "Issue Date", t.issueDate);
  //         check(typeName, i, "expiryDate", "Expiry Date", t.expiryDate);
  //       }

  //       // check(typeName, i, "passportNo", "Passport No", t.passportNo);
  //       // check(typeName, i, "issuingCountry", "Issuing Country", t.issuingCountry);
  //       // check(typeName, i, "nationality", "Nationality", t.nationality);
  //       // check(typeName, i, "issueDate", "Issue Date", t.issueDate);
  //       // check(typeName, i, "expiryDate", "Expiry Date", t.expiryDate);
  //     });
  //   };

  //   const adultList = travellers?.adults || [];
  //   if (adultList.length === 0) {
  //     newErrors["adult_empty"] = "Passenger Details required";
  //   } else {
  //     validateType(adultList, "adult");
  //   }

  //   if (flightAvailibilies?.[0]?.child > 0) {
  //     validateType(travellers?.children, "child");
  //   }

  //   if (flightAvailibilies?.[0]?.infant > 0) {
  //     validateType(travellers?.infants, "infant");
  //   }
  //   setError(newErrors);

  //   return Object.keys(newErrors).length === 0;
  // };
  //const inputRefs = useRef({});
  const validateTravellers = () => {
    let newErrors = {};
    let firstErrorField = null; // track first error

    const isEmpty = (value) => {
      if (value === null || value === undefined) return true;
      if (typeof value === "object") return true;
      if (value === 0) return false;
      if (value.toString().trim() === "") return true;
      if (value.toString().trim().toLowerCase() === "select") return true;
      return false;
    };

    const isValidName = (value) => {
      if (!value) return false;
      const regex = /^[A-Za-z ]{2,50}$/;
      return regex.test(value.trim());
    };

    const check = (type, index, field, label, value, isNameField = false) => {
      if (isEmpty(value)) {
        newErrors[`${type}_${index}_${field}`] = `${label} is required`;
        if (!firstErrorField) firstErrorField = { type, index, field };
      } else if (isNameField && !isValidName(value)) {
        newErrors[`${type}_${index}_${field}`] = `${label} must be A–Z only and 2–50 characters`;
        if (!firstErrorField) firstErrorField = { type, index, field };
      }
    };

    const validateType = (list, typeName) => {
      if (!Array.isArray(list)) list = [];

      if (list.length === 0) {
        newErrors[`${typeName}_empty`] = `${typeName.toUpperCase()} details are required`;
        if (!firstErrorField) firstErrorField = { type: typeName, index: 0, field: "title" };
        return;
      }

      list.forEach((t, i) => {
        if (!t) t = {};
        check(typeName, i, "title", "Title", t.title);
        check(typeName, i, "firstName", "First Name", t.firstName, true);
        check(typeName, i, "lastName", "Last Name", t.lastName, true);
        //check(typeName, i, "dob", "Date of Birth", t.dob);
        //check(typeName, i, "airline", "Airline", t.airline);

        if ("passportNo" in t) {
          check(typeName, i, "passportNo", "Passport No", t.passportNo);
          check(typeName, i, "issuingCountry", "Issuing Country", t.issuingCountry);
          check(typeName, i, "nationality", "Nationality", t.nationality);
          check(typeName, i, "issueDate", "Issue Date", t.issueDate);
          check(typeName, i, "expiryDate", "Expiry Date", t.expiryDate);
        }
      });
    };

    const adultList = travellers?.adults || [];
    if (adultList.length === 0) {
      newErrors["adult_empty"] = "Passenger Details required";
      if (!firstErrorField) firstErrorField = { type: "adult", index: 0, field: "title" };
    } else {
      validateType(adultList, "adult");
    }

    if (flightAvailibilies?.[0]?.child > 0) {
      validateType(travellers?.children, "child");
    }

    if (flightAvailibilies?.[0]?.infant > 0) {
      validateType(travellers?.infants, "infant");
    }

    setError(newErrors);
    return { isValid: Object.keys(newErrors).length === 0, firstErrorField };
  };

  const getSeatAvailability = async (segment) => {
    try {
      setLoadingSeats(true);
      setActiveSegment(segment);
      const response = await GetSeatAvailability(segment, oF, rF);
      const data = await response.json();

      setSeatLayout(data);
      const modal = new window.bootstrap.Modal(
        document.getElementById("SeatAvailability")
      );
      modal.show();

    } catch (error) {
      console.error("Seat API error", error);
    } finally {
      setLoadingSeats(false);
    }
  };


  const handlePaymentSubmit = async () => {
    setPaymentError("");
    setTermsError("");
    setSuccess("");

    // Payment Method Validation
    if (!paymentMethod) {
      setPaymentError("Please select a payment method before continuing.");
      return;
    }

    // Agency Credit Balance Validation
    if (paymentMethod === "AgencyCredit") {
      const balance = parseFloat(agencyDetails?.agencyDetails?.cashBalance || 0);
      if (balance <= 0) {
        setPaymentError("Insufficient agency balance for payment.");
        return;
      }
    }

    // Terms Checkbox Validation
    if (!acceptedTerms) {
      setTermsError("Please accept the Terms & Conditions before continuing.");
      return;
    }

    try {
      setLoading(true);
      //const response = await AddPassengerDetails(requestBody);
      const response = await AddPassengerDetails({
        clientCode: "BerryJourneys",
        key: key,
        referenceNo: referenceNo,
        contactDetails,
        travellers,
        ssrInfo,
        pricing,
        userName
      });
      console.log(response);
      if (response?.status === "Success") {
        setSuccess("Pax saved successfully!");

        //call here Api To collect Payment 
        const response = await CollectPayment({
          transactionID: referenceNo,
          referenceNo: referenceNo,
          userId: userName,
          service: "Flight",
          sessionId: key,
          transactionType: "",
          remarks: "",
          totalAmount: totalFare,
          creditLimit: true,
          status: "",
          paymentMode: {
            paymentModeType: "",
            cardType: "",
            productType: "",
            pgProvider: paymentMethod
          },
          //paymentMode: paymentMethod,
          ipAddress: "",
        });
        console.log("webPaymentLink", response.formHtml);
        if (response?.success === true && response?.message === "Payment form generated.") {
          window.open(response.formHtml, "_self");
          //window.open(response.formHtml, "_blank");
        }

        else if (response?.message === "Payment successful using Agency Wallet.") {
          setSuccess("Payment successful!!");
          const response = await FlightBooking({
            clientCode: "BerryJourneys",
            userID: userName,
            key: key,
            referenceNo: referenceNo,
          });
          //if (response?.message === "Success") {
          navigate(`/thankyou?ReferenceNo=${referenceNo}`);
          //}

        } else {
          setPaymentError(response?.message || "Payment fail. Try again.");
        }
      } else {
        setPaymentError(response?.data?.message || "Something went wrong. Try again.");
      }
    } catch (error) {
      console.error("Payment API Error:", error);
      setPaymentError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const SubmitApprovalRequest = async () => {
    setTermsError("");
    setSuccess("");

   
    // Terms Checkbox Validation
    if (!acceptedTerms) {
      setTermsError("Please accept the Terms & Conditions before continuing.");
      return;
    }

    try {
      setLoading(true);
      const response = await AddPassengerDetails({
        clientCode: "BerryJourneys",
        key: key,
        referenceNo: referenceNo,
        contactDetails,
        travellers,
        ssrInfo,
        pricing,
        userName
      });
      console.log(response);
      if (response?.status === "Success") {
        setSuccess("Pax saved successfully!");

        //call here Api To Approval Request
        const response = await ApprovalRequest({
          referenceNo: referenceNo,
          userId: userName,
          product: "Flight",
          level1Approver: "",
          level2Approver: "",
        });
        if (response?.success === true && response?.message === "Payment form generated.") {
          window.open(response.formHtml, "_self");
          //window.open(response.formHtml, "_blank");
        }

        else if (response?.message === "Payment successful using Agency Wallet.") {
          setSuccess("Payment successful!!");
          // const response = await FlightBooking({
          //   clientCode: "BerryJourneys",
          //   userID: userName,
          //   key: key,
          //   referenceNo: referenceNo,
          // });
          //if (response?.message === "Success") {
          navigate(`/thankyou?ReferenceNo=${referenceNo}`);

        } else {
          setPaymentError(response?.message || "Payment fail. Try again.");
        }
      } else {
        setPaymentError(response?.data?.message || "Something went wrong. Try again.");
      }
    } catch (error) {
      console.error("Payment API Error:", error);
      setPaymentError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header></Header>
      <section className='Booking_flight'>
        <div className='container_box'>
          <div className='row'>
            <div className='col-md-9'>
              <div className='box_shadow'>
                <div className="steps mb-4 d-flex justify-content-start">
                  <span className={step === 1 ? "active Payment" : "Payment"}>Travellers' Details</span>
                  <span className={step === 2 ? "active Payment" : "Payment"}>Confirm Booking</span>
                  <span className={step === 3 ? "active Payment" : "Payment"}>Payment</span>
                </div>

                {/* Step 1 */}
                {step === 1 && (
                  <div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Review Your Booking</h4>
                      {flightAvailibilies && flightAvailibilies.length > 0 && (
                        flightAvailibilies[0].TripType === "MultiCity" ? (
                          <>
                            <div className="row">
                              <div className="col-lg-12">
                                <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                <div className="row">
                                  <div className="col-md-2">
                                    <div className="flight_img">
                                      <img
                                        className="img_icon"
                                        src={`/assets/images/flight/${selectedFlight?.segments?.[0]?.airLineCode}.png`}
                                        alt={selectedFlight?.segments?.[0]?.airLineName || "flight"}
                                        onError={(e) => {
                                          e.target.src = "/assets/images/flight/flight_v.png"; // fallback
                                        }}
                                      />                                    </div>
                                    <div className="name_code">
                                      <span>IX - 1194</span>
                                      <span>Air India Express</span>
                                    </div>
                                  </div>
                                  <div className="col-md-10">
                                    <div className="row">
                                      <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                      <div className="col-md-3">
                                        <div className="timer">
                                          <p>Delhi</p>
                                          <h4>DEL <span>|</span> 23:30</h4>
                                          <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                          <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="deruation">
                                          <p>02:15  |  0 STOP </p>
                                          <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                          <p className="">
                                            <span>Economy </span>
                                            <span>Partial Refundable</span>
                                          </p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="timer">
                                          <p>Mumbai</p>
                                          <h4>BOM <span>|</span> 01:45</h4>
                                          <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                          <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="baggage">
                                          <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                          <p>Check-in :<strong>15 Kg / person</strong></p>
                                          <p>Cabin :<strong>07 Kg/ person</strong></p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {oF && oF.length > 0 && (
                              <>
                                <div className="row">
                                  {oF.map((segment, index) => (
                                    <div className="col-lg-12" key={index}>
                                      <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                      <div className="row">
                                        <div className="col-md-2">
                                          <div className="flight_img">
                                            {/* <img className="img_icon" src="/assets/images/flight/flight_v.png" alt="flight" /> */}
                                            <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                          </div>
                                          <div className="name_code">
                                            <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                            <span>{segment.airLineName}</span>
                                          </div>
                                        </div>
                                        <div className="col-md-10">
                                          <div className="row">
                                            <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.departCityName}</p>
                                                <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="deruation">
                                                {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                                  <p>{segment.duration}  |  {segment.numberOfStops} STOP | {segment.viaSector}</p>
                                                ) : (
                                                  <p>{segment.duration}  |  {segment.numberOfStops} STOP </p>
                                                )}

                                                <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                <p className="">
                                                  {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                    <span>{segment.travelClass}</span>
                                                  )}

                                                  {flightAvailibilies[0].isRefundable ? (
                                                    <span>Partially Refundable</span>
                                                  ) : (
                                                    <span>Non-Refundable</span>
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.arrivalCityName}</p>
                                                <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              {/* <div className="baggage">
                                                <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                <p>Check-in :<strong>15 Kg / person</strong></p>
                                                <p>Cabin :<strong>07 Kg/ person</strong></p>
                                              </div> */}
                                              {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                                <div className="baggage">
                                                  <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                  <p>Check-in :<strong>{segment.baggageDetails[0].baggage} Kg / person</strong></p>
                                                  <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} Kg/ person</strong></p>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}


                                </div>
                              </>
                            )}
                            {rF && rF.length > 0 && (
                              <>
                                <div className="row">
                                  {rF.map((segment, index) => (
                                    <div className="col-lg-12" key={index}>

                                      <p className="departure"><i className="fa fa-plane"></i> Return</p>
                                      <div className="row">
                                        <div className="col-md-2">
                                          <div className="flight_img">
                                            <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                          </div>
                                          <div className="name_code">
                                            <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                            <span>{segment.airLineName}</span>
                                          </div>
                                        </div>
                                        <div className="col-md-10">
                                          <div className="row">
                                            <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.departCityName}</p>
                                                <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="deruation">
                                                {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                                  <p>{segment.duration}  |  {segment.numberOfStops} STOP | {segment.viaSector}</p>
                                                ) : (
                                                  <p>{segment.duration}  |  {segment.numberOfStops} STOP </p>
                                                )}

                                                <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                <p className="">
                                                  {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                    <span>{segment.travelClass}</span>
                                                  )}

                                                  {flightAvailibilies[0].isRefundable ? (
                                                    <span>Partially Refundable</span>
                                                  ) : (
                                                    <span>Non-Refundable</span>
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.arrivalCityName}</p>
                                                <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                                <div className="baggage">
                                                  <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                  <p>Check-in :<strong>{segment.baggageDetails[0].baggage} Kg / person</strong></p>
                                                  <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} Kg/ person</strong></p>
                                                </div>
                                              )};
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))};
                                </div>
                              </>
                            )}

                          </>
                        )
                      )}

                      <h4 className="sub_heading">Enter Traveller Details</h4>
                      <div className="Traveller">
                        <h5>Contact Details</h5>
                        <div className="row">
                          <div className="col-md-5">
                            <div className="form-group">
                              <label className="">Email Address</label>
                              <input className="form-control form-control-solid" name="emailId" type="text" placeholder="."
                                readOnly
                                value={contactDetails.emailId} //agencyDetails.agencyDetails.email
                                onChange={ChangeContactDetails}
                              />
                            </div>
                          </div>
                          <div className="col-md-5">
                            <div className="form-group">
                              <label className="required">Contact Number</label>
                              <div className="d-flex">
                                <div className="selct">
                                  <select className="form-select form-select-solid"
                                    value={contactDetails.countryCode}
                                    onChange={ChangeContactDetails}
                                  >
                                    <option value="91">India (+91)</option>
                                    <option value="93">Afghanistan (+93)</option>
                                    <option value="355">Albania (+355)</option>
                                    <option value="213">Algeria (+213)</option>
                                    <option value="1 684">American Samoa (+1 684)</option>
                                    <option value="376">Andorra (+376)</option>
                                    <option value="244">Angola (+244)</option>
                                    <option value="1 264">Anguilla (+1 264)</option>
                                    <option value="672">Antarctica (+672)</option>
                                    <option value="1 268">Antigua and Barbuda (+1 268)</option>
                                    <option value="54">Argentina (+54)</option>
                                    <option value="374">Armenia (+374)</option>
                                    <option value="297">Aruba (+297)</option>
                                    <option value="61">Australia (+61)</option>
                                    <option value="43">Austria (+43)</option>
                                    <option value="994">Azerbaijan (+994)</option>
                                    <option value="1 242">Bahamas (+1 242)</option>
                                    <option value="973">Bahrain (+973)</option>
                                    <option value="880">Bangladesh (+880)</option>
                                    <option value="1 246">Barbados (+1 246)</option>
                                    <option value="375">Belarus (+375)</option>
                                    <option value="32">Belgium (+32)</option>
                                    <option value="501">Belize (+501)</option>
                                    <option value="229">Benin (+229)</option>
                                    <option value="1 441">Bermuda (+1 441)</option>
                                    <option value="975">Bhutan (+975)</option>
                                    <option value="591">Bolivia (+591)</option>
                                    <option value="387">Bosnia and Herzegovina (+387)</option>
                                    <option value="267">Botswana (+267)</option>
                                    <option value="55">Brazil (+55)</option>
                                    <option value="1 284">British Virgin Islands (+1 284)</option>
                                    <option value="673">Brunei (+673)</option>
                                    <option value="359">Bulgaria (+359)</option>
                                    <option value="226">Burkina Faso (+226)</option>
                                    <option value="95">Burma (Myanmar) (+95)</option>
                                    <option value="257">Burundi (+257)</option>
                                    <option value="855">Cambodia (+855)</option>
                                    <option value="237">Cameroon (+237)</option>
                                    <option value="1">Canada (+1)</option>
                                    <option value="238">Cape Verde (+238)</option>
                                    <option value="1 345">Cayman Islands (+1 345)</option>
                                    <option value="236">Central African Republic (+236)</option>
                                    <option value="235">Chad (+235)</option>
                                    <option value="56">Chile (+56)</option>
                                    <option value="86">China (+86)</option>
                                    <option value="61">Christmas Island (+61)</option>
                                    <option value="61">Cocos (Keeling) Islands (+61)</option>
                                    <option value="57">Colombia (+57)</option>
                                    <option value="269">Comoros (+269)</option>
                                    <option value="682">Cook Islands (+682)</option>
                                    <option value="506">Costa Rica (+506)</option>
                                    <option value="385">Croatia (+385)</option>
                                    <option value="53">Cuba (+53)</option>
                                    <option value="357">Cyprus (+357)</option>
                                    <option value="420">Czech Republic (+420)</option>
                                    <option value="243">Democratic Republic of the Congo (+243)</option>
                                    <option value="45">Denmark (+45)</option>
                                    <option value="253">Djibouti (+253)</option>
                                    <option value="1 767">Dominica (+1 767)</option>
                                    <option value="1 809">Dominican Republic (+1 809)</option>
                                    <option value="593">Ecuador (+593)</option>
                                    <option value="20">Egypt (+20)</option>
                                    <option value="503">El Salvador (+503)</option>
                                    <option value="240">Equatorial Guinea (+240)</option>
                                    <option value="291">Eritrea (+291)</option>
                                    <option value="372">Estonia (+372)</option>
                                    <option value="251">Ethiopia (+251)</option>
                                    <option value="500">Falkland Islands (+500)</option>
                                    <option value="298">Faroe Islands (+298)</option>
                                    <option value="679">Fiji (+679)</option>
                                    <option value="358">Finland (+358)</option>
                                    <option value="33">France (+33)</option>
                                    <option value="689">French Polynesia (+689)</option>
                                    <option value="241">Gabon (+241)</option>
                                    <option value="220">Gambia (+220)</option>
                                    <option value="970">Gaza Strip (+970)</option>
                                    <option value="995">Georgia (+995)</option>
                                    <option value="49">Germany (+49)</option>
                                    <option value="233">Ghana (+233)</option>
                                    <option value="350">Gibraltar (+350)</option>
                                    <option value="30">Greece (+30)</option>
                                    <option value="299">Greenland (+299)</option>
                                    <option value="1 473">Grenada (+1 473)</option>
                                    <option value="1 671">Guam (+1 671)</option>
                                    <option value="502">Guatemala (+502)</option>
                                    <option value="224">Guinea (+224)</option>
                                    <option value="245">Guinea-Bissau (+245)</option>
                                    <option value="592">Guyana (+592)</option>
                                    <option value="509">Haiti (+509)</option>
                                    <option value="39">Holy See (Vatican City) (+39)</option>
                                    <option value="504">Honduras (+504)</option>
                                    <option value="852">Hong Kong (+852)</option>
                                    <option value="36">Hungary (+36)</option>
                                    <option value="354">Iceland (+354)</option>
                                    {/* <option value="91">India (+91)</option> */}
                                    <option value="62">Indonesia (+62)</option>
                                    <option value="98">Iran (+98)</option>
                                    <option value="964">Iraq (+964)</option>
                                    <option value="353">Ireland (+353)</option>
                                    <option value="44">Isle of Man (+44)</option>
                                    <option value="972">Israel (+972)</option>
                                    <option value="39">Italy (+39)</option>
                                    <option value="225">Ivory Coast (+225)</option>
                                    <option value="1 876">Jamaica (+1 876)</option>
                                    <option value="81">Japan (+81)</option>
                                    <option value="962">Jordan (+962)</option>
                                    <option value="7">Kazakhstan (+7)</option>
                                    <option value="254">Kenya (+254)</option>
                                    <option value="686">Kiribati (+686)</option>
                                    <option value="381">Kosovo (+381)</option>
                                    <option value="965">Kuwait (+965)</option>
                                    <option value="996">Kyrgyzstan (+996)</option>
                                    <option value="856">Laos (+856)</option>
                                    <option value="371">Latvia (+371)</option>
                                    <option value="961">Lebanon (+961)</option>
                                    <option value="266">Lesotho (+266)</option>
                                    <option value="231">Liberia (+231)</option>
                                    <option value="218">Libya (+218)</option>
                                    <option value="423">Liechtenstein (+423)</option>
                                    <option value="370">Lithuania (+370)</option>
                                    <option value="352">Luxembourg (+352)</option>
                                    <option value="853">Macau (+853)</option>
                                    <option value="389">Macedonia (+389)</option>
                                    <option value="261">Madagascar (+261)</option>
                                    <option value="265">Malawi (+265)</option>
                                    <option value="60">Malaysia (+60)</option>
                                    <option value="960">Maldives (+960)</option>
                                    <option value="223">Mali (+223)</option>
                                    <option value="356">Malta (+356)</option>
                                    <option value="692">Marshall Islands (+692)</option>
                                    <option value="222">Mauritania (+222)</option>
                                    <option value="230">Mauritius (+230)</option>
                                    <option value="262">Mayotte (+262)</option>
                                    <option value="52">Mexico (+52)</option>
                                    <option value="691">Micronesia (+691)</option>
                                    <option value="373">Moldova (+373)</option>
                                    <option value="377">Monaco (+377)</option>
                                    <option value="976">Mongolia (+976)</option>
                                    <option value="382">Montenegro (+382)</option>
                                    <option value="1 664">Montserrat (+1 664)</option>
                                    <option value="212">Morocco (+212)</option>
                                    <option value="258">Mozambique (+258)</option>
                                    <option value="264">Namibia (+264)</option>
                                    <option value="674">Nauru (+674)</option>
                                    <option value="977">Nepal (+977)</option>
                                    <option value="31">Netherlands (+31)</option>
                                    <option value="599">Netherlands Antilles (+599)</option>
                                    <option value="687">New Caledonia (+687)</option>
                                    <option value="64">New Zealand (+64)</option>
                                    <option value="505">Nicaragua (+505)</option>
                                    <option value="227">Niger (+227)</option>
                                    <option value="234">Nigeria (+234)</option>
                                    <option value="683">Niue (+683)</option>
                                    <option value="672">Norfolk Island (+672)</option>
                                    <option value="850">North Korea (+850)</option>
                                    <option value="1 670">Northern Mariana Islands (+1 670)</option>
                                    <option value="47">Norway (+47)</option>
                                    <option value="968">Oman (+968)</option>
                                    <option value="92">Pakistan (+92)</option>
                                    <option value="680">Palau (+680)</option>
                                    <option value="507">Panama (+507)</option>
                                    <option value="675">Papua New Guinea (+675)</option>
                                    <option value="595">Paraguay (+595)</option>
                                    <option value="51">Peru (+51)</option>
                                    <option value="63">Philippines (+63)</option>
                                    <option value="870">Pitcairn Islands (+870)</option>
                                    <option value="48">Poland (+48)</option>
                                    <option value="351">Portugal (+351)</option>
                                    <option value="1">Puerto Rico (+1)</option>
                                    <option value="974">Qatar (+974)</option>
                                    <option value="242">Republic of the Congo (+242)</option>
                                    <option value="40">Romania (+40)</option>
                                    <option value="7">Russia (+7)</option>
                                    <option value="250">Rwanda (+250)</option>
                                    <option value="590">Saint Barthelemy (+590)</option>
                                    <option value="290">Saint Helena (+290)</option>
                                    <option value="1 869">Saint Kitts and Nevis (+1 869)</option>
                                    <option value="1 758">Saint Lucia (+1 758)</option>
                                    <option value="1 599">Saint Martin (+1 599)</option>
                                    <option value="508">Saint Pierre and Miquelon (+508)</option>
                                    <option value="1 784">Saint Vincent and the Grenadines (+1 784)</option>
                                    <option value="685">Samoa (+685)</option>
                                    <option value="378">San Marino (+378)</option>
                                    <option value="239">Sao Tome and Principe (+239)</option>
                                    <option value="966">Saudi Arabia (+966)</option>
                                    <option value="221">Senegal (+221)</option>
                                    <option value="381">Serbia (+381)</option>
                                    <option value="248">Seychelles (+248)</option>
                                    <option value="232">Sierra Leone (+232)</option>
                                    <option value="65">Singapore (+65)</option>
                                    <option value="421">Slovakia (+421)</option>
                                    <option value="386">Slovenia (+386)</option>
                                    <option value="677">Solomon Islands (+677)</option>
                                    <option value="252">Somalia (+252)</option>
                                    <option value="27">South Africa (+27)</option>
                                    <option value="82">South Korea (+82)</option>
                                    <option value="34">Spain (+34)</option>
                                    <option value="94">Sri Lanka (+94)</option>
                                    <option value="249">Sudan (+249)</option>
                                    <option value="597">Suriname (+597)</option>
                                    <option value="268">Swaziland (+268)</option>
                                    <option value="46">Sweden (+46)</option>
                                    <option value="41">Switzerland (+41)</option>
                                    <option value="963">Syria (+963)</option>
                                    <option value="886">Taiwan (+886)</option>
                                    <option value="992">Tajikistan (+992)</option>
                                    <option value="255">Tanzania (+255)</option>
                                    <option value="66">Thailand (+66)</option>
                                    <option value="670">Timor-Leste (+670)</option>
                                    <option value="228">Togo (+228)</option>
                                    <option value="690">Tokelau (+690)</option>
                                    <option value="676">Tonga (+676)</option>
                                    <option value="1 868">Trinidad and Tobago (+1 868)</option>
                                    <option value="216">Tunisia (+216)</option>
                                    <option value="90">Turkey (+90)</option>
                                    <option value="993">Turkmenistan (+993)</option>
                                    <option value="1 649">Turks and Caicos Islands (+1 649)</option>
                                    <option value="688">Tuvalu (+688)</option>
                                    <option value="256">Uganda (+256)</option>
                                    <option value="380">Ukraine (+380)</option>
                                    <option value="44">United Kingdom (+44)</option>
                                    <option value="1">United States (+1)</option>
                                    <option value="598">Uruguay (+598)</option>
                                    <option value="1 340">US Virgin Islands (+1 340)</option>
                                    <option value="998">Uzbekistan (+998)</option>
                                    <option value="678">Vanuatu (+678)</option>
                                    <option value="58">Venezuela (+58)</option>
                                    <option value="84">Vietnam (+84)</option>
                                    <option value="681">Wallis and Futuna (+681)</option>
                                    <option value="970">West Bank (+970)</option>
                                    <option value="967">Yemen (+967)</option>
                                    <option value="260">Zambia (+260)</option>
                                    <option value="263">Zimbabwe (+263)</option>
                                  </select>
                                </div>
                                <div className="inpt">
                                  <input className="form-control form-control-solid" name="mobile" type="text" placeholder="."
                                    value={contactDetails.mobile}
                                    onChange={ChangeContactDetails}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>

                          <p>Your booking details will sent to this email address and mobile number.</p>
                        </div>

                        <h5>Traveller Information</h5>
                        <p className="note"><span>Important Note :</span> Please ensure that the name of the passengers on the travel documents is the same on their government issued identity proof.</p>

                        {/* Adult */}
                        {error["adult_empty"] && (
                          <p className="text-danger fw-bold">{error["adult_empty"]}</p>
                        )}
                        {flightAvailibilies && flightAvailibilies[0].adult > 0 &&
                          Array.from({ length: flightAvailibilies[0].adult }).map((_, index) => (
                            // flightAvailibilies[0].adult.map((item, index) => (
                            <div className="row Adult" key={index}>
                              <div className="col-md-2">
                                <h4 className="Adult">Adult {index + 1}</h4>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex">
                                  <div className="selct">
                                    <select
                                      name={`adults[${index}].title`}
                                      className="form-select form-select-solid"
                                      onChange={(e) => handleTravellerChange("adults", index, "title", e.target.value)}
                                    >

                                      <option value="Select">Select</option>
                                      <option value="Mr">Mr.</option>
                                      <option value="Ms">Ms.</option>
                                      <option value="Mrs">Mrs.</option>

                                    </select>
                                    {error[`adult_${index}_title`] && (
                                      <span className="text-danger small">
                                        {error[`adult_${index}_title`]}
                                      </span>
                                    )}
                                  </div>
                                  <div className="inpt">

                                    <input className="form-control form-control-solid" name="{`adults[${index}].firstName`}" type="text" placeholder="First Name.."
                                      //ref={(el) => (inputRefs.current[`adults_${index}_firstName`] = el)}
                                      onChange={(e) => handleTravellerChange("adults", index, "firstName", e.target.value)}
                                      onKeyPress={(e) => {
                                        const char = e.key;
                                        const regex = /[A-Za-z ]/;
                                        if (!regex.test(char)) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    {error[`adult_${index}_firstName`] && (
                                      <span className="text-danger small">
                                        {error[`adult_${index}_firstName`]}
                                      </span>
                                    )}
                                  </div>
                                </div>

                              </div>
                              <div className="col-md-3">
                                <input className="form-control form-control-solid" name={`adults[${index}].lastName`} type="text" placeholder="Last Name.."
                                  onChange={(e) => handleTravellerChange("adults", index, "lastName", e.target.value)}
                                  onKeyPress={(e) => {
                                    const char = e.key;
                                    const regex = /[A-Za-z ]/; // allow letters and space only
                                    if (!regex.test(char)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {error[`adult_${index}_lastName`] && (
                                  <span className="text-danger small">
                                    {error[`adult_${index}_lastName`]}
                                  </span>
                                )}
                              </div>

                              {
                                flightAvailibilies?.flightAvailibilies?.[0]?.trip === "2" &&
                                (flightAvailibilies?.flightAvailibilies?.[0]?.sCode !== "Indigo" &&
                                  flightAvailibilies?.flightAvailibilies?.[0]?.sCode !== "SpiceJet") && (
                                  <>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Passport No</label>
                                        <input className="form-control form-control-solid" name={`adults[${index}].passportNo`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("adults", index, "passportNo", e.target.value)}
                                        />
                                        {error[`adult_${index}_passportNo`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_passportNo`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issuing Country</label>
                                        <input className="form-control form-control-solid" name={`adults[${index}].issuingCountry`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("adults", index, "issuingCountry", e.target.value)}
                                        />
                                        {error[`adult_${index}_issuingCountry`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_issuingCountry`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issue Date</label>
                                        {/* <input className="form-control form-control-solid" name="issueDate" defaultValue="" type="text" placeholder="."
                                    onChange={(e) => handleTravellerChange("adults", index, "issueDate", e.target.value)}
                                     /> */}
                                        <DatePicker
                                          name={`adults[${index}].issueDate`}
                                          selected={
                                            travellers?.adults?.[index]?.issueDate
                                              ? new Date(travellers.adults[index].issueDate)
                                              : null
                                          }
                                          onChange={(date) => {
                                            const formatted = date ? date.toISOString().split("T")[0] : "";
                                            handleTravellerChange("adults", index, "issueDate", formatted);
                                          }} className="form-control form-control-solid"
                                        />
                                        {error[`adult_${index}_issueDate`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_issueDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Expiry Date</label>
                                        {/* <input className="form-control form-control-solid" name="expiryDate" defaultValue="" type="text" placeholder="."
                                    onChange={(e) => handleTravellerChange("adults", index, "expiryDate", e.target.value)}
                                    /> */}
                                        <DatePicker
                                          name={`adults[${index}].expiryDate`}
                                          selected={
                                            travellers?.adults?.[index]?.expiryDate
                                              ? new Date(travellers.adults[index].expiryDate)
                                              : null
                                          }
                                          onChange={(date) => {
                                            const formatted = date ? date.toISOString().split("T")[0] : "";
                                            handleTravellerChange("adults", index, "expiryDate", formatted);
                                          }} className="form-control form-control-solid"
                                        />
                                        {error[`adult_${index}_expiryDate`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_expiryDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Nationality</label>
                                        <input className="form-control form-control-solid" name={`adults[${index}].nationality`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("adults", index, "nationality", e.target.value)}
                                        />
                                        {error[`adult_${index}_nationality`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_nationality`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">

                                      <DatePicker
                                        name={`adults[${index}].dob`}
                                        selected={
                                          travellers?.adults?.[index]?.dob
                                            ? new Date(travellers.adults[index].dob)
                                            : null
                                        }
                                        onChange={(date) => {
                                          const formatted = date ? date.toISOString().split("T")[0] : "";
                                          handleTravellerChange("adults", index, "dob", formatted);
                                        }}

                                        className="form-control form-control-solid"
                                        placeholderText="Date of Birth..."

                                        showYearDropdown
                                        showMonthDropdown
                                        yearDropdownItemNumber={100}
                                        scrollableYearDropdown
                                        maxDate={new Date()}
                                      />
                                      {/* {error[`adult_${index}_dob`] && (
                                        <span className="text-danger small">
                                          {error[`adult_${index}_dob`]}
                                        </span>
                                      )} */}
                                    </div>
                                  </>
                                )
                              }
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="">Airline</label>
                                      <select className="form-select form-select-solid"
                                        name={`adults[${index}].airline`}
                                        onChange={(e) => handleTravellerChange("adults", index, "airline", e.target.value)}
                                      >
                                        <option value="Select">Select</option>
                                        <option value="I8">Aboriginal Air Services(I8)-</option>
                                        <option value="9B">AccessRail(9B)-</option>
                                        <option value="WZ">Acvila Air(WZ)-</option>
                                        <option value="KI">Adam Air(KI)-</option>
                                        <option value="Z7">ADC Airlines(Z7)-</option>
                                        <option value="JP">Adria Airways(JP)-</option>
                                        <option value="DF">Aebal(DF)-</option>
                                      </select>
                                      {error[`adult_${index}_airline`] && (
                                        <span className="text-danger small">
                                          {error[`adult_${index}_airline`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="required">Frequent Flyer No</label>
                                      <input className="form-control form-control-solid" name={`adults[${index}].frequentFlyerNo`} defaultValue="" type="text" placeholder="."
                                        onChange={(e) => handleTravellerChange("adults", index, "frequentFlyerNo", e.target.value)}
                                      />
                                      {error[`adult_${index}_frequentFlyerNo`] && (
                                        <span className="text-danger small">
                                          {error[`adult_${index}_frequentFlyerNo`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-12 mt-5 mb-5">
                                <div className="form-check form-check-inline">
                                  <input className="form-check-input" id="Active" name={`adults[${index}].saveInfo`} type="checkbox" value="1"
                                    onChange={(e) => handleTravellerChange("adults", index, "saveInfo", e.target.checked)}
                                  />
                                  {error[`adult_${index}_saveInfo`] && (
                                    <span className="text-danger small">
                                      {error[`adult_${index}_saveInfo`]}
                                    </span>
                                  )}
                                  <label className="form-check-label" for="Active">Save/Update information for next booking.</label>
                                </div>
                              </div>
                            </div>
                          )
                          )}
                        {/* Child */}
                        {flightAvailibilies && flightAvailibilies[0].child > 0 &&
                          Array.from({ length: flightAvailibilies[0].child }).map((_, index) => (
                            <div className="row Child" key={index}>
                              <div className="col-md-2">
                                <h4 className="Adult">Child {index + 1}</h4>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex">
                                  <div className="selct">
                                    <select className="form-select form-select-solid"
                                      name={`children[${index}].title`}
                                      onChange={(e) => handleTravellerChange("children", index, "title", e.target.value)}
                                    >
                                      <option value="Select">Select</option>
                                      <option value="MR">Mast</option>
                                      <option value="MS">Miss</option>
                                    </select>
                                    {error[`child_${index}_title`] && (
                                      <span className="text-danger small">
                                        {error[`child_${index}_title`]}
                                      </span>
                                    )}
                                  </div>
                                  <div className="inpt">
                                    <input className="form-control form-control-solid" name={`children[${index}].firstName`} type="text" placeholder="First Name.."
                                      onChange={(e) => handleTravellerChange("children", index, "firstName", e.target.value)}
                                      onKeyPress={(e) => {
                                        const char = e.key;
                                        const regex = /[A-Za-z ]/;
                                        if (!regex.test(char)) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    {error[`child_${index}_firstName`] && (
                                      <span className="text-danger small">
                                        {error[`child_${index}_firstName`]}
                                      </span>
                                    )}
                                  </div>
                                </div>

                              </div>
                              <div className="col-md-3">
                                <input className="form-control form-control-solid" name={`children[${index}].lastName`} type="text" placeholder="Last Name.."
                                  onChange={(e) => handleTravellerChange("children", index, "lastName", e.target.value)}
                                  onKeyPress={(e) => {
                                    const char = e.key;
                                    const regex = /[A-Za-z ]/;
                                    if (!regex.test(char)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {error[`child_${index}_lastName`] && (
                                  <span className="text-danger small">
                                    {error[`child_${index}_lastName`]}
                                  </span>
                                )}
                              </div>
                              {
                                flightAvailibilies?.flightAvailibilies?.[0]?.trip === "2" &&
                                (flightAvailibilies?.flightAvailibilies?.[0]?.sCode !== "Indigo" &&
                                  flightAvailibilies?.flightAvailibilies?.[0]?.sCode !== "SpiceJet") && (
                                  <>

                                    <div className="col-md-3">
                                      <input className="form-control form-control-solid" name={`children[${index}].dob`} type="text" placeholder="Date of Birth.."
                                        onChange={(e) => handleTravellerChange("children", index, "dob", e.target.value)}
                                      />
                                      {error[`child_${index}_dob`] && (
                                        <span className="text-danger small">
                                          {error[`child_${index}_dob`]}
                                        </span>
                                      )}
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Passport No</label>
                                        <input className="form-control form-control-solid" name={`children[${index}].passportNo`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("children", index, "passportNo", e.target.value)}
                                        />
                                        {error[`child_${index}_passportNo`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_passportNo`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issuing Country</label>
                                        <input className="form-control form-control-solid" name={`children[${index}].issuingCountry`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("children", index, "issuingCountry", e.target.value)}
                                        />
                                        {error[`child_${index}_issuingCountry`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_issuingCountry`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Nationality</label>
                                        <input className="form-control form-control-solid" name={`children[${index}].nationality`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("children", index, "nationality", e.target.value)}
                                        />
                                        {error[`child_${index}_nationality`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_nationality`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issue Date</label>
                                        <input className="form-control form-control-solid" name={`children[${index}].issueDate`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("children", index, "issueDate", e.target.value)}
                                        />
                                        {error[`child_${index}_issueDate`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_issueDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Expiry Date</label>
                                        <input className="form-control form-control-solid" name={`children[${index}].expiryDate`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("children", index, "expiryDate", e.target.value)}
                                        />
                                        {error[`child_${index}_expiryDate`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_expiryDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )
                              }


                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="">Airline</label>
                                      <select className="form-select form-select-solid"
                                        name={`children[${index}].airline`}
                                        onChange={(e) => handleTravellerChange("children", index, "airline", e.target.value)}
                                      >
                                        <option value="Select">Select</option>
                                        <option value="I8">Aboriginal Air Services(I8)-</option>
                                        <option value="9B">AccessRail(9B)-</option>
                                        <option value="WZ">Acvila Air(WZ)-</option>
                                        <option value="KI">Adam Air(KI)-</option>
                                        <option value="Z7">ADC Airlines(Z7)-</option>
                                        <option value="JP">Adria Airways(JP)-</option>
                                        <option value="DF">Aebal(DF)-</option>
                                      </select>
                                      {error[`child_${index}_airline`] && (
                                        <span className="text-danger small">
                                          {error[`child_${index}_airline`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="required">Frequent Flyer No</label>
                                      <input className="form-control form-control-solid" name={`children[${index}].frequentFlyerNo`} defaultValue="" type="text" placeholder="."
                                        onChange={(e) => handleTravellerChange("children", index, "frequentFlyerNo", e.target.value)}
                                      />
                                      {error[`child_${index}_frequentFlyerNo`] && (
                                        <span className="text-danger small">
                                          {error[`child_${index}_frequentFlyerNo`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-12 mt-5 mb-5">
                                <div className="form-check form-check-inline">
                                  <input className="form-check-input" id="Active" name={`children[${index}].saveInfo`} type="checkbox" value="1"
                                    onChange={(e) => handleTravellerChange("children", index, "saveInfo", e.target.checked)}
                                  />
                                  {error[`child_${index}_saveInfo`] && (
                                    <span className="text-danger small">
                                      {error[`child_${index}_saveInfo`]}
                                    </span>
                                  )}
                                  <label className="form-check-label" for="Active">Save/Update information for next booking.</label>
                                </div>
                              </div>
                            </div>
                          ))}
                        {/* Infant */}
                        {flightAvailibilies && flightAvailibilies[0].infant > 0 &&
                          Array.from({ length: flightAvailibilies[0].infant }).map((_, index) => (
                            <div className="row Infant" key={index}>
                              <div className="col-md-2">
                                <h4 className="Adult">Infant {index + 1}</h4>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex">
                                  <div className="selct">
                                    <select className="form-select form-select-solid"
                                      name={`infants[${index}].title`}
                                      onChange={(e) => handleTravellerChange("infants", index, "title", e.target.value)}
                                    >
                                      <option value="Select">Select</option>
                                      <option value="Mr">Mr.</option>
                                      <option value="MS">Ms</option>
                                    </select>
                                    {error[`infant_${index}_title`] && (
                                      <span className="text-danger small">
                                        {error[`infant_${index}_title`]}
                                      </span>
                                    )}
                                  </div>
                                  <div className="inpt">
                                    <input className="form-control form-control-solid" name={`infants[${index}].firstName`} type="text" placeholder="First Name.."
                                      onChange={(e) => handleTravellerChange("infants", index, "firstName", e.target.value)}
                                      onKeyPress={(e) => {
                                        const char = e.key;
                                        const regex = /[A-Za-z ]/;
                                        if (!regex.test(char)) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    {error[`infant_${index}_firstName`] && (
                                      <span className="text-danger small">
                                        {error[`infant_${index}_firstName`]}
                                      </span>
                                    )}
                                  </div>
                                </div>

                              </div>
                              <div className="col-md-3">
                                <input className="form-control form-control-solid" name={`infants[${index}].lastName`} type="text" placeholder="Last Name.."
                                  onChange={(e) => handleTravellerChange("infants", index, "lastName", e.target.value)}
                                  onKeyPress={(e) => {
                                    const char = e.key;
                                    const regex = /[A-Za-z ]/;
                                    if (!regex.test(char)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {error[`infant_${index}_lastName`] && (
                                  <span className="text-danger small">
                                    {error[`infant_${index}_lastName`]}
                                  </span>
                                )}
                              </div>
                              {
                                flightAvailibilies?.flightAvailibilies?.[0]?.trip === "2" &&
                                (flightAvailibilies?.flightAvailibilies?.[0]?.sCode !== "Indigo" &&
                                  flightAvailibilies?.flightAvailibilies?.[0]?.sCode !== "SpiceJet") && (
                                  <>
                                    <div className="col-md-3">
                                      <input className="form-control form-control-solid" name={`infants[${index}].dob`} type="text" placeholder="Date of Birth.."
                                        onChange={(e) => handleTravellerChange("infants", index, "dob", e.target.value)}
                                      />
                                      {error[`infant_${index}_dob`] && (
                                        <span className="text-danger small">
                                          {error[`infant_${index}_dob`]}
                                        </span>
                                      )}
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Passport No</label>
                                        <input className="form-control form-control-solid" name={`infants[${index}].passportNo`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("infants", index, "passportNo", e.target.value)}
                                        />
                                        {error[`infant_${index}_passportNo`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_passportNo`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issuing Country</label>
                                        <input className="form-control form-control-solid" name={`infants[${index}].issuingCountry`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("infants", index, "issuingCountry", e.target.value)}
                                        />
                                        {error[`infant_${index}_issuingCountry`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_issuingCountry`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Nationality</label>
                                        <input className="form-control form-control-solid" name={`infants[${index}].nationality`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("infants", index, "nationality", e.target.value)}
                                        />
                                        {error[`infant_${index}_nationality`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_nationality`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issue Date</label>
                                        <input className="form-control form-control-solid" name={`infants[${index}].issueDate`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("infants", index, "issueDate", e.target.value)}
                                        />
                                        {error[`infant_${index}_issueDate`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_issueDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Expiry Date</label>
                                        <input className="form-control form-control-solid" name={`infants[${index}].expiryDate`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("infants", index, "expiryDate", e.target.value)}
                                        />
                                        {error[`infant_${index}_expiryDate`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_expiryDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )
                              }
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="">Airline</label>
                                      <select className="form-select form-select-solid"
                                        name={`infants[${index}].airline`}
                                        onChange={(e) => handleTravellerChange("infants", index, "airline", e.target.value)}
                                      >
                                        <option value="Select">Select</option>
                                        <option value="I8">Aboriginal Air Services(I8)-</option>
                                        <option value="9B">AccessRail(9B)-</option>
                                        <option value="WZ">Acvila Air(WZ)-</option>
                                        <option value="KI">Adam Air(KI)-</option>
                                        <option value="Z7">ADC Airlines(Z7)-</option>
                                        <option value="JP">Adria Airways(JP)-</option>
                                        <option value="DF">Aebal(DF)-</option>
                                      </select>
                                      {error[`infant_${index}_airline`] && (
                                        <span className="text-danger small">
                                          {error[`infant_${index}_airline`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="required">Frequent Flyer No</label>
                                      <input className="form-control form-control-solid" name={`infants[${index}].frequentFlyerNo`} defaultValue="" type="text" placeholder="."
                                        onChange={(e) => handleTravellerChange("infants", index, "frequentFlyerNo", e.target.value)}
                                      />
                                      {error[`infant_${index}_frequentFlyerNo`] && (
                                        <span className="text-danger small">
                                          {error[`infant_${index}_frequentFlyerNo`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-12 mt-5 mb-5">
                                <div className="form-check form-check-inline">
                                  <input className="form-check-input" id="Active" name={`infants[${index}].saveInfo`} type="checkbox" value="1"
                                    onChange={(e) => handleTravellerChange("infants", index, "saveInfo", e.target.checked)}
                                  />
                                  {error[`infant_${index}_saveInfo`] && (
                                    <span className="text-danger small">
                                      {error[`infant_${index}_saveInfo`]}
                                    </span>
                                  )}
                                  <label className="form-check-label" for="Active">Save/Update information for next booking.</label>
                                </div>
                              </div>
                            </div>
                          )
                          )}
                      </div>
                    </div>
                    {/* special Service start */}
                    <div className="row mb-10">

                      <div className="col-md-12">
                        <div className="depatre">
                          <h4 className="sub_heading">Service Requests <sub>(Optional)</sub></h4>
                          <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                              <a class="btn btn-primary nav-link" data-bs-toggle="tab" href="#SeatMap">Seat Map <i className="fa fa-plus"></i> </a>
                            </li>
                            <li class="nav-item">
                              <a class="btn btn-primary nav-link" data-bs-toggle="tab" href="#AddBaggage">Add Baggage <i className="fa fa-plus"></i> </a>
                            </li>
                            <li class="nav-item">
                              <a class="btn btn-primary nav-link" data-bs-toggle="tab" href="#AddMeal">Add Meal <i className="fa fa-plus"></i></a>
                            </li>
                          </ul>

                          <div class="tab-content">
                            <div id="SeatMap" class="tab-pane">
                              <div className="row">
                                <p className="preferences">Select seat preferences</p>
                                <div className="col-md-6">
                                  <div className="depatre">
                                    <p className="deprure">Departure <i className="fa fa-plane"></i></p>
                                    {oF?.map((segment) => {
                                      const seatsForThisSegment =
                                        selectedSeats?.[segment.flightNumber] || [];

                                      return (
                                        <p className="del_ui" key={segment.flightNumber}>
                                          {/* OPEN MODAL */}
                                          <span
                                            className="loctn"
                                            data-bs-toggle="modal"
                                            data-bs-target="#SeatAvailability"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => getSeatAvailability(segment)}
                                          >
                                            {segment.departAirportCode} → {segment.arrivalAirportCode} ({segment.flightNumber})
                                          </span>

                                          {/* SHOW SELECTED SEATS */}
                                          <span className="selSeat">
                                            Seats Selected:{" "}
                                            <strong>
                                              {seatsForThisSegment.length > 0
                                                ? seatsForThisSegment.join(", ")
                                                : "None"}
                                            </strong>
                                          </span>
                                        </p>
                                      );
                                    })}

                                    {/* MODAL SECTION */}
                                    <div className="modal fade" id="SeatAvailability">
                                      <div className="modal-dialog modal-xl">
                                        <div className="modal-content">

                                          <div className="modal-header">
                                            <h4 className="modal-title">Select Seat
                                              {activeSegment && `(${activeSegment.flightNumber})`}
                                            </h4>
                                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                          </div>

                                          <div className="modal-body">
                                            {loadingSeats ? (
                                              <p>Loading seat layout...</p>
                                            ) : (
                                              <SeatAvailability
                                                selectedFlight={activeSegment}
                                                seatLayout={seatLayout}
                                                selectedSeats={selectedSeats}
                                                setSelectedSeats={setSelectedSeats}
                                              />
                                            )}
                                            {/* <SeatAvailability
                                              selectedFlight={selectedFlight}
                                              selectedSeats={selectedSeats}
                                              setSelectedSeats={setSelectedSeats}
                                            /> */}
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div id="AddBaggage" class="tab-pane">
                              <p className="preferences">Add Baggage preferences</p>
                              {/* Adult */}

                              {flightAvailibilies && flightAvailibilies[0].adult > 0 &&
                                Array.from({ length: flightAvailibilies[0].adult }).map((_, index) => (
                                  // flightAvailibilies[0].adult.map((item, index) => (
                                  <div className="row mb-2" key={index}>
                                    <div className="col-md-2">
                                      <h4 className="Adult">Adult {index + 1}</h4>
                                    </div>
                                    <div className="col-md-5">
                                      <select className="form-select form-select-solid">
                                        <option>Select</option>
                                      </select>
                                    </div>
                                     <div className="col-md-3">
                                        <h5 className="mt-3"> Amount :<i className="fa fa-inr"></i> 908 </h5>                                                                            
                                    </div> 

                                  </div>
                                )
                                )}
                              {/* Child */}
                              {flightAvailibilies && flightAvailibilies[0].child > 0 &&
                                Array.from({ length: flightAvailibilies[0].child }).map((_, index) => (
                                  <div className="row mb-2" key={index}>
                                    <div className="col-md-2">
                                      <h4 className="Adult">Child {index + 1}</h4>
                                    </div>
                                     <div className="col-md-5">
                                      <select className="form-select form-select-solid">
                                        <option>Select</option>
                                      </select>
                                    </div>
                                     <div className="col-md-3">
                                        <h5 className="mt-3"> Amount :<i className="fa fa-inr"></i> 908 </h5>                                                                            
                                    </div> 

                                  </div>
                                ))}
                              {/* Infant */}
                              {flightAvailibilies && flightAvailibilies[0].infant > 0 &&
                                Array.from({ length: flightAvailibilies[0].infant }).map((_, index) => (
                                  <div className="row mb-2" key={index}>
                                    <div className="col-md-2">
                                      <h4 className="Adult">Infant {index + 1}</h4>
                                    </div>
                                     <div className="col-md-5">
                                      <select className="form-select form-select-solid">
                                        <option>Select</option>
                                      </select>
                                    </div>
                                     <div className="col-md-3">
                                        <h5 className="mt-3"> Amount :<i className="fa fa-inr"></i> 908 </h5>                                                                            
                                    </div> 

                                  </div>
                                )
                                )}
                            </div>
                            <div id="AddMeal" class="tab-pane fade">
                              <p className="preferences">Add Meal preferences</p>
                              {/* Adult */}

                              {flightAvailibilies && flightAvailibilies[0].adult > 0 &&
                                Array.from({ length: flightAvailibilies[0].adult }).map((_, index) => (
                                  // flightAvailibilies[0].adult.map((item, index) => (
                                  <div className="row mb-2" key={index}>
                                    <div className="col-md-2">
                                      <h4 className="Adult">Adult {index + 1}</h4>
                                    </div>
                                    <div className="col-md-5">
                                      <select className="form-select form-select-solid">
                                        <option>Select</option>
                                      </select>
                                    </div>
                                     <div className="col-md-3">
                                        <h5 className="mt-3"> Amount :<i className="fa fa-inr"></i> 908 </h5>                                                                            
                                    </div> 

                                  </div>
                                )
                                )}
                              {/* Child */}
                              {flightAvailibilies && flightAvailibilies[0].child > 0 &&
                                Array.from({ length: flightAvailibilies[0].child }).map((_, index) => (
                                  <div className="row mb-2" key={index}>
                                    <div className="col-md-2">
                                      <h4 className="Adult">Child {index + 1}</h4>
                                    </div>
                                     <div className="col-md-5">
                                      <select className="form-select form-select-solid">
                                        <option>Select</option>
                                      </select>
                                    </div>
                                     <div className="col-md-3">
                                        <h5 className="mt-3"> Amount :<i className="fa fa-inr"></i> 908 </h5>                                                                            
                                    </div> 

                                  </div>
                                ))}
                              {/* Infant */}
                              {flightAvailibilies && flightAvailibilies[0].infant > 0 &&
                                Array.from({ length: flightAvailibilies[0].infant }).map((_, index) => (
                                  <div className="row mb-2" key={index}>
                                    <div className="col-md-2">
                                      <h4 className="Adult">Infant {index + 1}</h4>
                                    </div>
                                    <div className="col-md-5">
                                      <select className="form-select form-select-solid">
                                        <option>Select</option>
                                      </select>
                                    </div>
                                    <div className="col-md-3">
                                        <h5 className="mt-3"> Amount :<i className="fa fa-inr"></i> 908 </h5>                                                                            
                                    </div>

                                  </div>
                                )
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* special Service End */}
                    <div className="button-list">
                      <a className="btn-btn-border" href="/flight">
                        Back To Search
                      </a>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          nextStep();
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                )}

                {/* Step 2 */}
                {step === 2 && (
                  <div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Fligth Details</h4>
                      <div className="row">

                        {flightAvailibilies && flightAvailibilies.length > 0 && (
                          flightAvailibilies[0].TripType === "MultiCity" ? (
                            <>
                              <div className="row">
                                <div className="col-lg-12">
                                  <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                  <div className="row">
                                    <div className="col-md-2">
                                      <div className="flight_img">
                                        <img
                                          className="img_icon"
                                          src={`/assets/images/flight/${selectedFlight?.segments?.[0]?.airLineCode}.png`}
                                          alt={selectedFlight?.segments?.[0]?.airLineName || "flight"}
                                          onError={(e) => {
                                            e.target.src = "/assets/images/flight/flight_v.png"; // fallback
                                          }}
                                        />                                      </div>
                                      <div className="name_code">
                                        <span>IX - 1194</span>
                                        <span>Air India Express</span>
                                      </div>
                                    </div>
                                    <div className="col-md-10">
                                      <div className="row">
                                        <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>Delhi</p>
                                            <h4>DEL <span>|</span> 23:30</h4>
                                            <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                            <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="deruation">
                                            <p>02:15  |  0 STOP </p>
                                            <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                            <p className="">
                                              <span>Economy </span>
                                              <span>Partial Refundable</span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>Mumbai</p>
                                            <h4>BOM <span>|</span> 01:45</h4>
                                            <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                            <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="baggage">
                                            <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                            <p>Check-in :<strong>15 Kg / person</strong></p>
                                            <p>Cabin :<strong>07 Kg/ person</strong></p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {oF && oF.length > 0 && (
                                <>
                                  <div className="row">
                                    {oF.map((segment, index) => (
                                      <div className="col-lg-12" key={index}>
                                        <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                        <div className="row">
                                          <div className="col-md-2">
                                            <div className="flight_img">
                                              <img className="img_icon" src="/assets/images/flight/flight_v.png" alt="flight" />
                                              {/* <img className="img_icon" src={`/assets/images/flight/${segment.marketingCarrier}.png`} alt="flight" /> */}
                                            </div>
                                            <div className="name_code">
                                              <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                              <span>{segment.airLineName}</span>
                                            </div>
                                          </div>
                                          <div className="col-md-10">
                                            <div className="row">
                                              <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                              <div className="col-md-3">
                                                <div className="timer">
                                                  <p>{segment.departCityName}</p>
                                                  <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                                  <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                                    weekday: "short",
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    hour12: false
                                                  })}</p>
                                                  <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="deruation">
                                                  {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                                    <p>{segment.duration}  |  {segment.numberOfStops} STOP | {segment.viaSector}</p>
                                                  ) : (
                                                    <p>{segment.duration}  |  {segment.numberOfStops} STOP </p>
                                                  )}

                                                  <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                  <p className="">
                                                    {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                      <span>{segment.travelClass}</span>
                                                    )}

                                                    {flightAvailibilies[0].isRefundable ? (
                                                      <span>Partially Refundable</span>
                                                    ) : (
                                                      <span>Non-Refundable</span>
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="timer">
                                                  <p>{segment.arrivalCityName}</p>
                                                  <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                                  <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                                    weekday: "short",
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    hour12: false
                                                  })}</p>
                                                  <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="baggage">
                                                  <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                  <p>Check-in :<strong>15 Kg / person</strong></p>
                                                  <p>Cabin :<strong>07 Kg/ person</strong></p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}


                                  </div>
                                </>
                              )}
                              {rF && rF.length > 0 && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                      <div className="row">
                                        <div className="col-md-2">
                                          <div className="flight_img">
                                            <img
                                              className="img_icon"
                                              src={`/assets/images/flight/${selectedFlight?.segments?.[0]?.airLineCode}.png`}
                                              alt={selectedFlight?.segments?.[0]?.airLineName || "flight"}
                                              onError={(e) => {
                                                e.target.src = "/assets/images/flight/flight_v.png"; // fallback
                                              }}
                                            />                                          </div>
                                          <div className="name_code">
                                            <span>{flightAvailibilies[0].sCode}</span>
                                            <span>{flightAvailibilies[0].sCode}</span>
                                          </div>
                                        </div>
                                        <div className="col-md-10">
                                          <div className="row">
                                            <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>Delhi</p>
                                                <h4>DEL <span>|</span> 23:30</h4>
                                                <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                                <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="deruation">
                                                <p>02:15  |  0 STOP </p>
                                                <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                <p className="">
                                                  <span>Economy </span>
                                                  <span>Partial Refundable</span>
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>Mumbai</p>
                                                <h4>BOM <span>|</span> 01:45</h4>
                                                <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                                <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="baggage">
                                                <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                <p>Check-in :<strong>15 Kg / person</strong></p>
                                                <p>Cabin :<strong>07 Kg/ person</strong></p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}

                            </>
                          )
                        )}

                        {/* <div className="col-lg-12 Repter">
                          <div className="row">
                            <div className="col-md-2">
                              <div className="flight_img">
                                <img className="img_icon" src="/assets/images/flight/flight_v.png" alt="flight" />
                              </div>
                              <div className="name_code">
                                <span>IX - 1194</span>
                                <span>Air India Express</span>
                              </div>
                            </div>
                            <div className="col-md-10">
                              <div className="row">
                                <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                <div className="col-md-3">
                                  <div className="timer">
                                    <p>Delhi</p>
                                    <h4>DEL <span>|</span> 23:30</h4>
                                    <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                    <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="deruation">
                                    <p>02:15  |  0 STOP </p>
                                    <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                    <p className="">
                                      <span>Economy </span>
                                      <span>Partial Refundable</span>
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="timer">
                                    <p>Mumbai</p>
                                    <h4>BOM <span>|</span> 01:45</h4>
                                    <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                    <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="baggage">
                                    <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                    <p>Check-in :<strong>15 Kg / person</strong></p>
                                    <p>Cabin :<strong>07 Kg/ person</strong></p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p className="note-block box-condensed">
                          <span>Change planes at Doha (DOH), Connecting Time:  02:55 | Connecting flight may depart from a different terminal</span>
                        </p>

                        <div className="col-lg-12 Repter">
                          <div className="row">
                            <div className="col-md-2">
                              <div className="flight_img">
                                <img className="img_icon" src="/assets/images/flight/flight_v.png" alt="flight" />
                              </div>
                              <div className="name_code">
                                <span>IX - 1194</span>
                                <span>Air India Express</span>
                              </div>
                            </div>
                            <div className="col-md-10">
                              <div className="row">
                                <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                <div className="col-md-3">
                                  <div className="timer">
                                    <p>Delhi</p>
                                    <h4>DEL <span>|</span> 23:30</h4>
                                    <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                    <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="deruation">
                                    <p>02:15  |  0 STOP </p>
                                    <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                    <p className="">
                                      <span>Economy </span>
                                      <span>Partial Refundable</span>
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="timer">
                                    <p>Mumbai</p>
                                    <h4>BOM <span>|</span> 01:45</h4>
                                    <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                    <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="baggage">
                                    <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                    <p>Check-in :<strong>15 Kg / person</strong></p>
                                    <p>Cabin :<strong>07 Kg/ person</strong></p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p className="note-block box-condensed">
                          <span>Change planes at Doha (DOH), Connecting Time:  02:55 | Connecting flight may depart from a different terminal</span>
                        </p> */}

                      </div>
                      {/* Repeat */}
                    </div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Passenger Details</h4>
                      <div className="row">
                        <div className="col-lg-12">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>Type</th>
                                <th>Name</th>
                                <th>Date of Birth</th>
                                <th>Nationality</th>
                                <th>Passport No.</th>
                                <th>Issuing Country</th>
                                <th>Expiry Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Adults */}
                              {travellers.adults.map((t, i) => (
                                <tr key={`adult-${i}`}>
                                  <td>{i + 1}</td>
                                  <td>Adult</td>
                                  <td>{t.title} {t.firstName} {t.lastName}</td>
                                  <td>{t.dob}</td>
                                  <td>{t.nationality}</td>
                                  <td>{t.passportNo}</td>
                                  <td>{t.issuingCountry}</td>
                                  <td>{t.expiryDate}</td>
                                </tr>
                              ))}

                              {/* Children */}
                              {travellers.children.map((t, i) => (
                                <tr key={`child-${i}`}>
                                  <td>{i + 1}</td>
                                  <td>Child</td>
                                  <td>{t.title} {t.firstName} {t.lastName}</td>
                                  <td>{t.dob}</td>
                                  <td>{t.nationality}</td>
                                  <td>{t.passportNo}</td>
                                  <td>{t.issuingCountry}</td>
                                  <td>{t.expiryDate}</td>
                                </tr>
                              ))}

                              {/* Infants */}
                              {travellers.infants.map((t, i) => (
                                <tr key={`infant-${i}`}>
                                  <td>{i + 1}</td>
                                  <td>Infant</td>
                                  <td>{t.title} {t.firstName} {t.lastName}</td>
                                  <td>{t.dob}</td>
                                  <td>{t.nationality}</td>
                                  <td>{t.passportNo}</td>
                                  <td>{t.issuingCountry}</td>
                                  <td>{t.expiryDate}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Contact Details</h4>
                      <div className="row">
                        <div className="col-lg-12">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Email Address</th>
                                <th>Contact Number</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{contactDetails.emailId}</td>
                                <td>{contactDetails.countryCode} {contactDetails.mobile}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="button-list">
                      <button className="btn-btn-border"
                        onClick={() => {
                          prevStep();
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}>
                        Back
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          nextStep();
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                )}

                {/* Step 3 */}
                {step === 3 && (
                  <div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Payment</h4>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="paymnt">
                            <div className="paymnt_lft">
                              <ul className="nav nav-tabs paynt" role="tablist">
                                <li className="nav-item">
                                  <a className="nav-link active" data-bs-toggle="tab" href="#AgencyCredit">Agency Credit</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">HDFC</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" data-bs-toggle="tab" href="#DebitCard">Debit Card</a>
                                </li>
                              </ul>
                            </div>
                            <div className="paymnt_Rgt">
                              <div className="tab-content">
                                <div id="AgencyCredit" className="container tab-pane active">
                                  <div className="balnce">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="paymentMethod"
                                      id="agencyCreditRadio"
                                      value="AgencyWallet"
                                      checked={paymentMethod === "AgencyWallet"}
                                      onChange={(e) => {
                                        setPaymentMethod(e.target.value)
                                        setPaymentError("");
                                      }}
                                    />
                                    <i className="fa fa-inr"></i>{agencyDetails.agencyDetails.cashBalance}</div>
                                </div>
                                <div id="CreditCard" className="container tab-pane fade">
                                  <div className="balnce">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="HdfcBank"
                                      id="HdfcBankRadio"
                                      value="HdfcBank"
                                      checked={paymentMethod === "HdfcBank"}
                                      onChange={(e) => {
                                        setPaymentMethod(e.target.value)
                                        setPaymentError("");
                                      }
                                      }
                                    />
                                    <img src="/assets/images/hdfc-logo.png" alt="payment" /> </div>
                                </div>
                                <div id="DebitCard" className="container tab-pane fade">
                                  <div className="balnce">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="paymentMethod"
                                      id="debitCardRadio"
                                      value="DebitCard"
                                      checked={paymentMethod === "DebitCard"}
                                      onChange={(e) => {
                                        setPaymentMethod(e.target.value)
                                        setPaymentError("");
                                      }}
                                    />
                                    <i className="fa fa-inr"></i>36565</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {paymentError && (
                            <div className="alert alert-danger fw-bold mt-3 py-2">
                              {paymentError}
                            </div>
                          )}
                          {/* {error && <p className="text-danger mt-3">{error}</p>}
                          {success && <p className="text-success mt-3">{success}</p>} */}
                        </div>

                        <div className="col-md-12 mt-5 mb-5">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              id="termsCheckbox"
                              name="Status"
                              type="checkbox"
                              checked={acceptedTerms}
                              onChange={(e) => {
                                setAcceptedTerms(e.target.checked);
                                if (e.target.checked) setTermsError("");
                              }}
                            />
                            {/* <input className="form-check-input" id="Active" name="Status" type="checkbox" value="1" /> */}
                            <label className="form-check-label Active" for="Active"> By clicking this button, I understand &amp; accept with the	Rules &amp; Restrictions of this fare,the Privacy Policy <a data-bs-toggle="modal" data-bs-target="#term-cond" className="weak">Terms &amp; Conditions</a></label>
                          </div>
                          {termsError && (
                            <div className="alert alert-danger fw-bold mt-3 py-2">
                              {termsError}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {success && (
                      <div className="col-md-12 mt-3 mb-4">
                        <div className="alert alert-success text-center fw-bold py-2 rounded">
                          {success}
                        </div>
                      </div>
                    )}

                    <div className="button-list">
                      <button
                        className="btn-btn-border"
                        onClick={() => {
                          prevStep();
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        Back
                      </button>
                      <button className="btn btn-primary" onClick={SubmitApprovalRequest}>
                        Request For Approval
                      </button>
                      <button className="btn btn-primary" onClick={handlePaymentSubmit}>
                        Pay & Book
                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>
            <div className='col-md-3 po_sticky'>
              <div className='box_shadow sticky'>
                <h6>Fare Summary</h6>
                <div className="accordion" id="kt_accordion_1">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_1">
                      <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_1" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                        <div className='flex'>
                          <span> Base Fare</span>
                          <span><i className='fa fa-inr'></i> {totalBFare.toFixed(2)} </span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_1" className="accordion-collapse collapse show" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">

                        {flightAvailibilies && flightAvailibilies.length > 0 && flightAvailibilies[0].adult > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].adult} Adult(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {adultTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {flightAvailibilies && flightAvailibilies.length > 0 && flightAvailibilies[0].child > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].child} Child(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {childTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {flightAvailibilies && flightAvailibilies.length > 0 && flightAvailibilies[0].infant > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].infant} Infant(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {infantTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_2">
                      <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_2" aria-expanded="false" aria-controls="kt_accordion_1_body_2">
                        <div className='flex'>
                          <span>Fee & Surcharges</span>
                          <span> <i className='fa fa-inr'></i> {flightAvailibilies &&
                            (
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalOtherTax || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalServiceTax || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.managementFee || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.baggageCharge || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.mealCharge || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.managementFeeTax || 0),
                                0
                              )
                            ).toFixed(2)}</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_2" className="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_2" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">
                        <div className='flex'>
                          <span>Baggage Charge <i class="fa-regular fa-circle-xmark"></i></span>
                          <span><i className='fa fa-inr'></i>
                            {flightAvailibilies &&
                              flightAvailibilies
                                .reduce((sum, x) => sum + parseFloat(x.fareDetails?.baggageCharge || 0), 0)
                                .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span>Meal Charge <i class="fa-regular fa-circle-xmark"></i></span>
                          <span><i className='fa fa-inr'></i>{flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.mealCharge || 0), 0)
                              .toFixed(2)} </span>
                        </div>
                        <div className='flex'>
                          <span> Fuel Surcharge</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.totalFuelSurcharge || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span> Tax</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            (
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalOtherTax || 0),
                                0
                              ) -
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.gSTAmount || 0),
                                0
                              ) -
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalFuelSurcharge || 0),
                                0
                              )
                            ).toFixed(2)}</span>
                        </div>

                        <div className='flex'>
                          <span> Booking Surcharge</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.managementFee || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_3">
                      <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_3" aria-expanded="false" aria-controls="kt_accordion_1_body_3">
                        <div className='flex'>
                          <span>Total Fare</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.totalFare || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_3" className="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_3" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">
                        <div className='flex'>
                          <span> Markup</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.agencyMarkUp || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span> Commission</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.agencyCommission || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span> Net Fare</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.agencyAmount || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flexes'>
                  <div className='totals'>GRAND TOTAL</div>
                  <div className='tolt_price'><i className='fa fa-inr'></i> {flightAvailibilies &&
                    flightAvailibilies
                      .reduce((sum, x) => sum + parseFloat(x.fareDetails?.totalFare || 0), 0)
                      .toFixed(2)}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section >

      {/* model pop start */}
      < div className="modal fade" id="term-cond" >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Terms And Conditions</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              Modal body..
            </div>
          </div>
        </div>
      </div >

    </>

  )
};

export default Booking;
